<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <!--section class="home">
      <div class="in-flex" id="menuderecha">
        <ul class="nav flex-column">
          <li class="nav-item">
              <button type="button" class="btn btn-secondary btn-block" id="btn1" (click)="IrIndicadoresChv()">
                Cartera Hipotecaria de Vivienda
              </button>
          </li>
          <li class="nav-item">
            <div class="btn-group dropend btn-block">
              <button type="button" class="btn btn-secondary btn-block" id="btn2">
                Financiación de Vivienda
              </button>
              <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-expanded="false">
                <span class="visually-hidden">Toggle Dropright</span>
              </button>
              <div class="dropdown-menu dropend">
                <a class="dropdown-item" (click)="IrIndicadoresFivi()">Indicadores mensual</a>
                <a class="dropdown-item" (click)="IrIndicadoresFiviTrimestral()">Indicadores trimestral</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
  </section-->
  <div class="row">
    <div class="col-3" style="text-align: left; margin: 5px;">
      <button type="button" class="btn btn-secondary btn-block" (click)="IrIndicadoresChv()" style="overflow: hidden; white-space: normal; max-width: 100%;">Cartera Hipotecaria de Vivienda</button>
    </div>
  </div>
  <div class="row">
    <div class="col-3" style="text-align: left; margin: 5px;">
      <div class="btn-group dropright btn-block">
        <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" style="overflow: hidden; white-space: normal; max-width: 100%;">
          Financiación de Vivienda
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" (click)="IrIndicadoresFivi()">Indicadores mensual</a></li>
          <li><a class="dropdown-item" (click)="IrIndicadoresFiviTrimestral()">Indicadores trimestral</a></li>
        </ul>
      </div>
    </div>
  </div>
</body>
